import {
  Box,
  ButtonGroup,
  Container,
  Flex,
  Heading,
  HStack,
  IconButton,
  Image,
  Tag,
  Text,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import {
  FaEnvelope,
  FaGithub,
  FaInstagram,
  FaLinkedin,
  FaPhone,
  FaTwitter,
} from "react-icons/fa";
import Education from "./Education";
import poto from "../images/poto.png";

export default function Banner() {
  return (
    <Container maxW={"7xl"} alignItems="center" my={5}>
      <Flex
        width={"100%"}
        maxW={["full", "full", "7xl"]}
        justifyContent="center"
        alignItems={"center"}
        flexDir={["column", "column", "row", "row"]}
      >
        <Flex
          width={["md", "md", "2xl"]}
          flexDir={"column"}
          justifyContent="space-between"
          bgColor={"white"}
          color="black"
          maxHeight="2xl"
          minHeight={"4xl"}
          borderRadius="3xl"
          p="10"
          mb={10}
        >
          <Box>
            <Flex alignItems={"center"} justifyContent="center">
              <Image
                borderColor={"gray.100"}
                borderRadius="full"
                src={poto}
                width="32"
              />
            </Flex>

            <Heading textAlign={"center"}>Muhammad David Kurniawan</Heading>

            <Text fontSize={"sm"} textAlign="center">
              I am David, a fifth semester student currently studying for a
              Bachelor's Degree in Informatics Engineering at Dian Nuswantoro
              University, Semarang. I have an interest in Front End Development
              using React JS and Mobile Application Development using React
              Native. I am looking for <Tag variant={"solid"} bg={"primary.600"}>internship</Tag>
              <br /> (Degree Completion in 2024).
            </Text>

            <VStack my={4}>
              <Tag px={5} variant={"subtle"} colorScheme="primary">
                Frontend Web Developer
              </Tag>
              <Tag px={5} variant={"subtle"} colorScheme="primary">
                Mobile Apps Developer
              </Tag>
            </VStack>
            <Box
              orientation="horizontal"
              bgColor="gray.300"
              my={4}
              height={0.2}
            />
            {/* Icons  */}
            <VStack spacing={6} alignItems="start">
              <HStack>
                <Box me={2}>
                  <IconButton
                    shadow={"md"}
                    variant={"ghost"}
                    border="1px solid"
                    borderColor={"gray.300"}
                  >
                    <FaEnvelope />
                  </IconButton>
                </Box>
                <VStack alignItems={"start"} spacing={0.1}>
                  <Text fontSize={"sm"}>Email</Text>
                  <Text fontWeight={"600"}>
                    <a
                      href="mailto:kurniawanflix@gmail.com"
                      target="_blank"
                      rel="noreferrer"
                      style={{ textDecoration: "none", color: "black" }}
                    >
                      kurniawanflix@gmail.com
                    </a>
                  </Text>
                </VStack>
              </HStack>

              <HStack>
                <Box me={2}>
                  <IconButton
                    shadow={"md"}
                    variant={"ghost"}
                    border="1px solid"
                    borderColor={"gray.300"}
                  >
                    <FaPhone />
                  </IconButton>
                </Box>
                <VStack alignItems={"start"} spacing={0.1}>
                  <Text fontSize={"sm"}>Phone</Text>
                  <Text fontWeight={"600"}>
                    <a
                      href="tel:+6285290004925"
                      target="_blank"
                      rel="noreferrer"
                      style={{ textDecoration: "none", color: "black" }}
                    >
                      +62 852 9000 4925
                    </a>
                  </Text>
                </VStack>
              </HStack>

              <HStack>
                <Box me={2}>
                  <IconButton
                    shadow={"md"}
                    variant={"ghost"}
                    border="1px solid"
                    borderColor={"gray.300"}
                  >
                    <FaGithub />
                  </IconButton>
                </Box>
                <VStack alignItems={"start"} spacing={0.1}>
                  <Text fontSize={"sm"}>Github</Text>
                  <Text fontWeight={"600"}>
                    {" "}
                    <a
                      href="https://github.com/kurniawanflix"
                      target="_blank"
                      rel="noreferrer"
                      style={{ textDecoration: "none", color: "black" }}
                    >
                      kurniawanflix
                    </a>
                  </Text>
                </VStack>
              </HStack>

              <HStack>
                <Box me={2}>
                  <IconButton
                    shadow={"md"}
                    variant={"ghost"}
                    border="1px solid"
                    borderColor={"gray.300"}
                  >
                    <FaLinkedin />
                  </IconButton>
                </Box>
                <VStack alignItems={"start"} spacing={0.1}>
                  <Text fontSize={"sm"}>Linkedin</Text>
                  <Text fontWeight={"600"}>
                    <a
                      href="https://www.linkedin.com/in/kurniawanflix/"
                      target="_blank"
                      rel="noreferrer"
                      style={{ textDecoration: "none", color: "black" }}
                    >
                      Muhammad David Kurniawan
                    </a>
                  </Text>
                </VStack>
              </HStack>

              <HStack>
                <Box me={2}>
                  <IconButton
                    shadow={"md"}
                    variant={"ghost"}
                    border="1px solid"
                    borderColor={"gray.300"}
                  >
                    <FaTwitter />
                  </IconButton>
                </Box>
                <VStack alignItems={"start"} spacing={0.1}>
                  <Text fontSize={"sm"}>Twitter</Text>
                  <Text fontWeight={"600"}>
                    <a
                      href="https://twitter.com/kurniawanflix"
                      target="_blank"
                      rel="noreferrer"
                      style={{ textDecoration: "none", color: "black" }}
                    >
                      kurniawanflix
                    </a>
                  </Text>
                </VStack>
              </HStack>
            </VStack>
          </Box>

          <ButtonGroup
            justifyContent={"center"}
            alignItems={"center"}
            variant="ghost"
            spacing={1.9}
          >
            <IconButton
              _hover={{
                color: "primary.700",
                bgColor: "primary.50",
                border: "1px solid",
                borderColor: "primary.700",
              }}
            >
              <a
                href="https://www.linkedin.com/in/kurniawanflix/"
                target="_blank"
                rel="noreferrer"
                style={{ textDecoration: "none", color: "black" }}
              >
                <FaLinkedin size={24} />
              </a>
            </IconButton>
            <IconButton
              _hover={{
                color: "primary.700",
                bgColor: "primary.50",
                border: "1px solid",
                borderColor: "primary.700",
              }}
            >
              <a
                href="https://instagram.com/kurniawanflix"
                target="_blank"
                rel="noreferrer"
                style={{ textDecoration: "none", color: "black" }}
              >
                <FaInstagram size={24} />
              </a>
            </IconButton>
            <IconButton
              _hover={{
                color: "primary.700",
                bgColor: "primary.50",
                border: "1px solid",
                borderColor: "primary.700",
              }}
            >
              <a
                href="https://twitter.com/kurniawanflix"
                target="_blank"
                rel="noreferrer"
                style={{ textDecoration: "none", color: "black" }}
              >
                <FaTwitter size={24} />
              </a>
            </IconButton>
          </ButtonGroup>
        </Flex>
        <Box
          ms={["0", "0", "8"]}
          flexDir={"column"}
          justifyContent="space-between"
          bgColor={"white"}
          color="black"
          maxHeight="4xl"
          scrollBehavior={"smooth"}
          minHeight={"4xl"}
          borderRadius="3xl"
          p="10"
          mb={10}
        >
          <Heading>Education and Experience</Heading>
          <Education />
        </Box>
      </Flex>
    </Container>
  );
}
